module.exports = __webpack_public_path__ + "static/media/agilite-logo-full-web.04bd37fc.png";